import React from 'react'
import { Hero } from './Hero'
import Container from '../Container'

export default function LandingPage() {
  return (
    <Container>
      <div className='top-fold-bkgd'></div>
      <div className="
          grid
          grid-cols-1
          gap-8
        ">
        <Hero />
      </div>
    </Container>
  )
}
